import { useRequest } from 'ahooks';
import { message } from 'antd';
import { useCallback, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { getSensitiveWordList, searchSensitiveWord } from '../api';

export default function useSensitiveWords() {
  const { t } = useTranslate();
  const [keyword, setKeyword] = useState('');
  const [pagination, setPagination] = useState({
    pageNum: 1,
    pageSize: 10,
  });

  const { data, loading, refresh } = useRequest(
    async () => {
      const params = { ...pagination };
      if (keyword.trim()) {
        return searchSensitiveWord({ ...params, keyword: keyword.trim() });
      }
      return getSensitiveWordList(params);
    },
    {
      refreshDeps: [keyword, pagination.pageNum, pagination.pageSize],
      onError: () => message.error(t('translation.操作失败，请稍后再试')),
    },
  );

  const onSearch = useCallback((value: string) => {
    setKeyword(value);
    setPagination((prev) => ({ ...prev, pageNum: 1 }));
  }, []);

  const onPageChange = useCallback((pageNum: number, pageSize: number) => {
    setPagination({ pageNum, pageSize });
  }, []);

  return {
    list: data?.list,
    total: data?.total,
    loading,
    keyword,
    pagination,
    onSearch,
    onPageChange,
    refresh,
  };
}
